document.addEventListener('DOMContentLoaded', function() {
  var drawer = document.getElementById('main-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  var toggle = document.querySelector('.drawer-toggle');
  var closeBtn = document.querySelector('.drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('drawer--open');
    overlay && overlay.classList.add('drawer-overlay--visible');
    toggle && toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('drawer--open');
    overlay && overlay.classList.remove('drawer-overlay--visible');
    toggle && toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle && toggle.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay && overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });  
});